import { useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'

// AUTOTONE
import autotone from '../../asset/autotone/autotone_before.png'
import applyautotone from '../../asset/autotone/autotone_after.png'

// PRESET
import preset from '../../asset/preset/preset_original.jpg'
import agedphoto from '../../asset/preset/preset_aged_photo.jpg'
import crossprocess from '../../asset/preset/preset_cross_process.jpg'
import custompresets from '../../asset/preset/preset_custom_presets.jpg'
import matte from '../../asset/preset/preset_matte.jpg'
import turquoisered from '../../asset/preset/preset_turquoise_red.jpg'

// SMART OBJECT
import smartobject from '../../asset/smartobject/smartobject_original.png'
import pink from '../../asset/smartobject/smartobject_pink.png'
import scratch from '../../asset/smartobject/smartobject_scratch.png'
import circles from '../../asset/smartobject/smartobject_circles.png'

// IMAGE CUTOUT
import cutout from '../../asset/imagecutout/imagecutout_original.jpg'
import addbackgroundcolor from '../../asset/imagecutout/imagecutout_addbackgroundcolor.jpg'
import removebackground from '../../asset/imagecutout/imagecutout_removebackground.png'

// TEXT LAYER
import textlayer from '../../asset/textlayer/textlayer_original.jpg'
import changetextcolor from '../../asset/textlayer/textlayer_color.jpg'
import changefont from '../../asset/textlayer/textlayer_font.jpg'
import changetextsize from '../../asset/textlayer/textlayer_size.jpg'
import changetextweight from '../../asset/textlayer/textlayer_weight.jpg'

// PHOTOSHOP ACTIONS
import psactions from '../../asset/psactions/psactions_original.jpg'
import bannergeneration from '../../asset/psactions/psactions_bannergeneration.jpg'
import camerarawfilter from '../../asset/psactions/psactions_camerarawfilter.jpg'
import graphicdesign from '../../asset/psactions/psactions_graphicdesign.jpg'

const TAG_ORIGINAL = '__original'

const imageEffect = { // action to image
    autotone: {
        [TAG_ORIGINAL]: autotone,
        applyautotone
    },
    preset: {
        [TAG_ORIGINAL]: preset,
        agedphoto,
        crossprocess,
        custompresets,
        matte,
        turquoisered
    },
    smartobject: {
        [TAG_ORIGINAL]: smartobject,
        pink,
        scratch,
        circles
    },
    textlayer: {
        [TAG_ORIGINAL]: textlayer,
        changefont,
        changetextcolor,
        changetextweight,
        changetextsize
    },
    imagecutout: {
        [TAG_ORIGINAL]: cutout,
        addbackgroundcolor,
        removebackground
    },
    psactions: {
        [TAG_ORIGINAL]: psactions,
        bannergeneration,
        camerarawfilter,
        graphicdesign
    }
}

export default function useImageEffect ({ group }) {
    const { action } = useContext(EasybakeContext)
    // const { action, ut } = useContext(EasybakeContext)
    if (action === 'bannergeneration') {
        // console.log(`ut: ${ut}`) // TODO debug
    }

    // FUTURE: useState(), useEffect(), React.Suspense to retrieve from API when in Phase II, etc
    const effectsGroup = imageEffect[group] || {}
    const beforeImage = effectsGroup[TAG_ORIGINAL]
    const afterImage = (effectsGroup[action] || beforeImage)

    return {
        beforeImage,
        afterImage
    }
}
